import { render, staticRenderFns } from "./Furusato.vue?vue&type=template&id=13f90bb1&scoped=true"
import script from "./Furusato.vue?vue&type=script&lang=js"
export * from "./Furusato.vue?vue&type=script&lang=js"
import style0 from "./Furusato.vue?vue&type=style&index=0&id=13f90bb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f90bb1",
  null
  
)

export default component.exports